<section class="page">

  <!-- HERO -->
  <header class="hero">
    <div class="hero__bg">
      <div class="hero__orb hero__orb--primary"></div>
      <div class="hero__orb hero__orb--secondary"></div>
    </div>
    <div class="hero__content">
      <div class="hero__kicker">{{ 'home.product.contact.hero.kicker' | translate }}</div>
      <h1 class="hero__title">{{ 'home.product.contact.form.title' | translate }}</h1>
      <p class="hero__subtitle">{{ 'home.product.contact.hero.subtitle' | translate }}</p>
    </div>
  </header>

  <!-- FORM -->
  <div class="form-card">
    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="form-body">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>{{ 'home.product.contact.form.label_type' | translate }}</mat-label>
        <mat-select formControlName="type" required>
          @for (option of contactTypes; track option) {
            <mat-option [value]="option.value">
              {{ option.viewValue }}
            </mat-option>
          }
        </mat-select>
        @if (contactForm.get('type')?.hasError('required')) {
          <mat-error>
            {{ 'home.product.contact.form.errors.type_required' | translate }}
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>{{ 'home.product.contact.form.label_description' | translate }}</mat-label>
        <textarea
          matInput
          formControlName="description"
          placeholder="{{ 'home.product.contact.form.placeholder_description' | translate }}"
          rows="5"
          required>
        </textarea>
        @if (contactForm.get('description')?.hasError('required')) {
          <mat-error>
            {{ 'home.product.contact.form.errors.description_required' | translate }}
          </mat-error>
        }
      </mat-form-field>

      <div class="form-actions">
        <button mat-flat-button class="btn-submit" type="submit" [disabled]="!contactForm.touched || contactForm.invalid || submitting">
          {{ 'buttons.submit' | translate }}
        </button>
      </div>
    </form>
  </div>

</section>
